import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { BaseResponsePagination } from '../../commons/class/BaseResponsePagination.interface';
import { NotificacionesICOIJDto } from './interfaces/NotificacionesICOIJDto.interface';
import { postInterfaceExpedienteElectronico, respuestaExpedienteElectronico } from './interfaces/respuestaExpedienteElectronico.interface';
import { API_INTERCONEXION, API_INTERCONEXION_VISORBYTOKEN, ENV_TOKEN } from '../../app-module.token';
import { ResponseTokenInterface } from './interfaces/response-token-interface';

@Injectable({ providedIn: 'root' })
export class expedienteElectronicoService {
  private readonly baseUrl = 'oaj.icoij.gateway/icoij/notificacionesICOI';
  private baseUrlEE = "";

  private httpService: HttpService = inject(HttpService);
  private http: HttpClient = inject(HttpClient);
  readonly environment = inject(ENV_TOKEN);
  private apiInterconexion = inject(API_INTERCONEXION);
  private metodoVysorByToken = inject(API_INTERCONEXION_VISORBYTOKEN);

  constructor() {
    this.baseUrlEE = `${this.environment.apiBaseUrlItxEE}/${this.environment.gatewayItxEE}`;
  }

  /**
   * Busca notificaciones según los parámetros proporcionados, se construye la ruta para la consulta utilizando los parámetros de paginación, ID de órgano y consulta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta como un Observable con un objeto genérico que contiene una paginación de notificaciones
   * @param page 
   * @param pageSize 
   * @param idOrgano 
   * @param query 
   * @returns 
   */
  buscarNotificaciones(page: number, pageSize: number, idOrgano: number, query = ''): Observable<BaseResponsePagination<NotificacionesICOIJDto[]>> {
    const params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize)
      .set('idOrgano', idOrgano)
      .set('query', query);


    return this.httpService.getRequest(`${this.baseUrl}/BusquedaNotificaciones${this.buildQueryString(params)}`) as Observable<BaseResponsePagination<NotificacionesICOIJDto[]>>;
  }

  /**
   * Construye una cadena de consulta a partir de los parámetros HTTP proporcionados, se convierte el objeto HttpParams en una cadena de consulta y se retorna la cadena resultante con un prefijo '?' si hay parámetros o una cadena vacía si no hay parámetros
   * @param params 
   * @returns 
   */
  private buildQueryString(params: HttpParams): string {
    const query = params.toString();
    return query ? `?${query}` : '';
  }

  /**
   * Envía un expediente electrónico, se construye la ruta para el envío utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param postExpElec 
   * @returns 
   */
  public postExpedienteElectronico(postExpElec: postInterfaceExpedienteElectronico): Observable<respuestaExpedienteElectronico> {
    const headers = new HttpHeaders();
    const url = `${this.apiInterconexion}${this.metodoVysorByToken}`;
    return this.httpService.postRequest(url, postExpElec, { headers }) as Observable<respuestaExpedienteElectronico>;
  }

  /**
   * Obtiene un token para acceder al visor de expedientes electrónicos, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
   * @returns 
   */
  getToken(): Observable<any> {
    const url = `${this.baseUrlEE}/api/Ebook`;
    return this.http
      .get<ResponseTokenInterface>(url)
      .pipe(map((resp) => resp ?? null));
  }

}